module.exports = __webpack_public_path__ + "img/config-mipres.f6f47dfe.png";